const USER_ACTION_TYPES = {
  SIGN_OUT_USER: 'SIGN_OUT_USER',
  SIGN_IN_USER: 'SIGN_IN_USER',
  SIGN_UP_USER: 'SIGN_UP_USER',
  SIGN_IN_FAILURE: 'SIGN_IN_FAILURE',
  SIGN_IN_GOOGLE_USER: 'SIGN_IN_GOOGLE_USER',
}

export default USER_ACTION_TYPES
